<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hPJtpr/tc-custom/9781680572247.jpg?1726574163293" alt="This image is the cover for the book Empty Graves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Empty Graves
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the <i>New York Times</i>–bestselling author of <i>V-Wars, </i>sixteen horror stories “written with great verve . . . for die hard zombie fans” (<i>Publishers Weekly)</i>.</b></p><p> Bram Stoker Award winner Jonathan Maberry is a master of the zombie tale. <i>Empty Graves: Tales of the Living Dead </i>is emotionally charged and disturbing. These stories range across the genres of horror, science fiction, and biological thriller without ever straying from the fascinating humanity at the core. </p><p> Together in a single action-packed collection, these sixteen gritty tales of the living dead span Maberr’s career, including an exclusive never-before-published short story. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan  Maberry, Ken Foree
      </h2>
      
      <p class="authorDescription body article">JONATHAN MABERRY is a NY Times bestselling suspense novelist, five-time Bram Stoker Award winner, and comic book writer. His vampire apocalypse book series, V-WARS, is being produced as a Netflix original series, starring Ian Somerhalder (LOST, VAMPIRE DIARIES) and will debut in early 2019. His other works include the Joe Ledger thrillers, Glimpse, the Rot & Ruin series, the Dead of Night series, The Wolfman, X-Files Origins: Devil’s Advocate, and many others. His YA space travel novel, Mars One, is in development for film; and his novel Glimpse and the V-Wars shared-world vampire apocalypse series are being developed for TV, as is his bestselling Joe Ledger thriller series. He is the editor of many anthologies including the X-Files, Aliens: Bug Hunt, Nights of the Living Dead (co-edited with zombie genre creator George A. Romero). His comics include Captain America, the Bram Stoker Award-winning Bad Blood, Black Panther, Punisher, Marvel Zombies Return, and more. His Rot & Ruin novels were included in the Ten Best Horror Novels for Young Adults. His first novel, Ghost Road Blues was named one of the 25 Best Horror Novels of the New Millennium. A board game version of V-Wars: A Game of Blood and Betrayal was based on his noels and comics. He was a featured expert on the History Channel’s Zombies: A Living History and True Monsters. He is one third of the very popular and mildly weird Three Guys With Beards podcast. He is a board member of the Horror Writers Association and the president of the International Association of Media Tie-in Writers. Jonathan lives in Del Mar, California with his wife, Sara Jo. www.jonathanmaberry.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?313acb94